//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Features.ShipDesign.js";
import "../no/Builder.js";
import "../no/Expression.js";
import "../Features/Features.ShipDesign.SectionViewBuilder.js";
import "../Features/Features.ShipDesign.ShipStructureBuilder.js";
import "../Drawings/Drawings.SelectDraftingViewList.js";
import "../no/Features.js";
import "../no/ugmath.js";
import "../no/Expression.js";
import "../no/SelectObjectList.js";
let d=[[[1,"BackProximity",0,"Expression",0],[0,"Denominator",1,0],[1,"FrontProximity",0,"Expression",0],[0,"Numerator",1,0],[0,"SectionRule",1,1],[1,"SectionView",0,"Features.ShipDesign.SectionViewBuilder",0],[1,"ShipStructure",0,"Features.ShipDesign.ShipStructureBuilder",0],[0,"SymmetricalStructure",1,1],[1,"ViewList",0,"Drawings.SelectDraftingViewList",0]],[[["origin","normal","frontProximity","backProximity","num_focus_plates"],"FindFocusPlates",{R_:{focus_plates:"NXObject[]"}},4,0],[["sectionPlane","num_focus_plates"],"FindFocusPlates1",{R_:{focus_plates:"NXObject[]"}},1,0]],[]];
SPLM.Features.ShipDesign.SectionEditorBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Features.ShipDesign.SectionEditorBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;